import React from "react";

export const IconEyeOff = () => (
  <svg className='icon-password' viewBox='0 0 24 24'>
    <path d='M17.81 13.395a8.947 8.947 0 0 0 3.182-5.771 1 1 0 0 0-1.984-.249C18.57 10.867 15.556 13.5 12 13.5s-6.569-2.633-7.008-6.125a1 1 0 1 0-1.984.249 8.947 8.947 0 0 0 3.183 5.771L3.88 15.707a1.003 1.003 0 0 0 0 1.414 1.003 1.003 0 0 0 1.414 0l2.603-2.603c.954.482 2.001.8 3.104.921V19c0 .55.45 1 1 1s1-.45 1-1v-3.561a9.062 9.062 0 0 0 3.103-.921l2.604 2.603a1.003 1.003 0 0 0 1.414 0 1.003 1.003 0 0 0 0-1.414l-2.312-2.312z' />
  </svg>
);

export const IconEService = () => (
  <svg
    id='icon_e-services'
    data-name='icon &gt; e-services'
    xmlns='http://www.w3.org/2000/svg'
    width='33.6'
    height='33.599'
    viewBox='0 0 33.6 33.599'>
    <g id='customer'>
      <g id='Group_993' data-name='Group 993' transform='translate(0 15.484)'>
        <g id='Group_992' data-name='Group 992'>
          <path
            id='Path_3610'
            data-name='Path 3610'
            d='M32.549,237.051a2.952,2.952,0,0,0-4.065.245L25.591,240.4a2.958,2.958,0,0,0-2.82-2.078H17.608c-.392,0-.523-.15-1.2-.674a6.9,6.9,0,0,0-9.079.022l-1.9,1.671a2.941,2.941,0,0,0-2.707-.034L.544,240.4a.985.985,0,0,0-.44,1.321L6.01,253.529a.985.985,0,0,0,1.321.44l2.177-1.089a2.951,2.951,0,0,0,1.631-2.745H22.771a6.923,6.923,0,0,0,5.512-2.756l4.725-6.3A2.945,2.945,0,0,0,32.549,237.051ZM8.627,251.12l-1.3.648L2.3,241.718l1.3-.648a.984.984,0,0,1,1.32.44L9.067,249.8A.984.984,0,0,1,8.627,251.12ZM31.434,239.9l-4.725,6.3a4.944,4.944,0,0,1-3.937,1.969H10.452L6.763,240.79l1.863-1.64a4.934,4.934,0,0,1,6.5,0,3.484,3.484,0,0,0,2.479,1.143h5.163a.984.984,0,0,1,0,1.969H17.744a.984.984,0,1,0,0,1.969H23.43a2.961,2.961,0,0,0,2.161-.94l4.334-4.652a.984.984,0,0,1,1.509,1.26Z'
            transform='translate(0 -235.959)'
            fill='#4c6085'
          />
        </g>
      </g>
      <g id='Group_995' data-name='Group 995' transform='translate(11.877)'>
        <g id='Group_994' data-name='Group 994'>
          <path
            id='Path_3611'
            data-name='Path 3611'
            d='M189.813,6.73A3.921,3.921,0,0,0,190.9,4.016a3.991,3.991,0,0,0-3.937-4,4.056,4.056,0,0,0-4,4,3.864,3.864,0,0,0,1.125,2.722,6,6,0,0,0-3.094,5.218v.984a.985.985,0,0,0,.984.984h9.909a.985.985,0,0,0,.984-.984v-.984A6,6,0,0,0,189.813,6.73Zm-2.848-4.748a2.029,2.029,0,0,1,1.969,2.034,1.971,1.971,0,0,1-1.969,1.969,2.029,2.029,0,0,1-2.034-1.969A2.088,2.088,0,0,1,186.966,1.982Zm-4,9.974a4.056,4.056,0,0,1,4-4,3.975,3.975,0,0,1,3.937,4Z'
            transform='translate(-180.994 -0.013)'
            fill='#4c6085'
          />
        </g>
      </g>
    </g>
  </svg>
);

export const IconECom = () => (
  <svg
    id='shopping'
    xmlns='http://www.w3.org/2000/svg'
    width='36.15'
    height='30.915'
    viewBox='0 0 36.15 30.915'>
    <g id='shopping-cart'>
      <g id='Group_971' data-name='Group 971' transform='translate(0 0)'>
        <path
          id='Path_3602'
          data-name='Path 3602'
          d='M10.1,59H30.855a1.071,1.071,0,0,0,1.026-.765l4.224-14.184a1.071,1.071,0,0,0-1.026-1.377H7.822L6.381,37.832a1.071,1.071,0,0,0-1.026-.765H1.071a1.071,1.071,0,1,0,0,2.142H4.556L5.99,44.025c0,.016.009.032.014.047l3.81,12.794a4.183,4.183,0,0,0,.283,8.356h1.063a3.831,3.831,0,0,0,7.357,0H24.2a3.831,3.831,0,0,0,7.357,0h1.38a1.071,1.071,0,1,0,0-2.142h-1.38a3.831,3.831,0,0,0-7.357,0H18.518a3.831,3.831,0,0,0-7.357,0H10.1A2.041,2.041,0,0,1,10.1,59ZM25.809,44.813h7.833l-1.474,4.95H25.809Zm0,7.092H31.53l-1.474,4.95H25.809Zm-7.925-7.092h5.783v4.95H17.885v-4.95Zm0,7.092h5.783v4.95H17.885Zm-2.142,4.95h-3.7l-1.474-4.95h5.17ZM8.46,44.813h7.282v4.95H9.935ZM27.879,62.461a1.69,1.69,0,1,1-1.69,1.69A1.692,1.692,0,0,1,27.879,62.461Zm-13.039,0a1.69,1.69,0,1,1-1.69,1.69A1.692,1.692,0,0,1,14.84,62.461Z'
          transform='translate(0 -37.067)'
          fill='#4c6085'
        />
      </g>
    </g>
  </svg>
);

export const IconEBills = () => (
  <svg
    id='icon_bills_payment'
    data-name='icon &gt; bills payment'
    xmlns='http://www.w3.org/2000/svg'
    width='25.512'
    height='30.63'
    viewBox='0 0 25.512 30.63'>
    <g id='receipt' transform='translate(0.082)'>
      <g id='Group_977' data-name='Group 977' transform='translate(0)'>
        <g id='Group_976' data-name='Group 976'>
          <path
            id='Path_3605'
            data-name='Path 3605'
            d='M64.875,2.324,61.739.517,58.6,2.324,55.468.517,52.333,2.324,48.3,0V24.085H43.481v3.237a3.311,3.311,0,0,0,3.307,3.307H65.6a3.311,3.311,0,0,0,3.307-3.307V0ZM46.788,28.833a1.513,1.513,0,0,1-1.511-1.511V25.881H62.294v1.441a3.288,3.288,0,0,0,.366,1.511Zm18.813,0a1.513,1.513,0,0,1-1.511-1.511V24.085H50.1V3.108L52.333,4.4,55.468,2.59,58.6,4.4,61.739,2.59,64.875,4.4l2.238-1.289V27.322h0A1.513,1.513,0,0,1,65.6,28.833Z'
            transform='translate(-43.481)'
            fill='#4c6085'
          />
        </g>
      </g>
      <g id='Group_979' data-name='Group 979' transform='translate(8.41 8.105)'>
        <g id='Group_978' data-name='Group 978'>
          <rect
            id='Rectangle_299'
            data-name='Rectangle 299'
            width='13.425'
            height='1.796'
            fill='#4c6085'
          />
        </g>
      </g>
      <g id='Group_981' data-name='Group 981' transform='translate(8.41 11.53)'>
        <g id='Group_980' data-name='Group 980'>
          <rect
            id='Rectangle_300'
            data-name='Rectangle 300'
            width='13.425'
            height='1.796'
            fill='#4c6085'
          />
        </g>
      </g>
      <g
        id='Group_983'
        data-name='Group 983'
        transform='translate(8.41 14.955)'>
        <g id='Group_982' data-name='Group 982'>
          <rect
            id='Rectangle_301'
            data-name='Rectangle 301'
            width='6.712'
            height='1.796'
            fill='#4c6085'
          />
        </g>
      </g>
    </g>
  </svg>
);

export const IconEGov = () => (
  <svg
    id='icon_gov'
    data-name='icon &gt; gov'
    xmlns='http://www.w3.org/2000/svg'
    width='33.265'
    height='37'
    viewBox='0 0 33.265 37'>
    <g id='government_1_' data-name='government (1)'>
      <path
        id='Path_3584'
        data-name='Path 3584'
        d='M28.722,18.475V14.138H24.1a6.655,6.655,0,0,0-6.315-6.023H17.61V6.264H22.1V0H15.661V8.115h-.174a6.655,6.655,0,0,0-6.315,6.023H4.549v4.337H0V37H33.268V18.475ZM17.61,2.168h2.537V4.1H17.61Zm-2.123,8.115h2.3a4.582,4.582,0,0,1,4.331,3.854H11.156a4.582,4.582,0,0,1,4.331-3.854ZM6.5,16.306H26.773v2.169H6.5ZM18.325,34.832H14.946V30.159h3.379Zm12.994,0H20.275V27.991H13v6.841H1.952V20.643H31.319Z'
        transform='translate(-0.003)'
        fill='#4c6085'
      />
      <path
        id='Path_3585'
        data-name='Path 3585'
        d='M55.96,316.773h2.2v5.089h-2.2Z'
        transform='translate(-51.121 -295.155)'
        fill='#4c6085'
      />
      <path
        id='Path_3586'
        data-name='Path 3586'
        d='M117.959,316.773h1.953v5.089h-1.953Z'
        transform='translate(-109.811 -295.155)'
        fill='#4c6085'
      />
      <path
        id='Path_3587'
        data-name='Path 3587'
        d='M55.96,396.441h2.2v5.388h-2.2Z'
        transform='translate(-51.121 -369.426)'
        fill='#4c6085'
      />
      <path
        id='Path_3588'
        data-name='Path 3588'
        d='M117.959,396.441h1.953v5.389h-1.953Z'
        transform='translate(-109.811 -369.426)'
        fill='#4c6085'
      />
      <path
        id='Path_3589'
        data-name='Path 3589'
        d='M363.959,396.441h2.084v5.388h-2.084Z'
        transform='translate(-340.795 -369.426)'
        fill='#4c6085'
      />
      <path
        id='Path_3590'
        data-name='Path 3590'
        d='M425.958,396.441h2.033v5.388h-2.033Z'
        transform='translate(-399.564 -369.426)'
        fill='#4c6085'
      />
      <path
        id='Path_3591'
        data-name='Path 3591'
        d='M363.959,316.773h2.084v5.089h-2.084Z'
        transform='translate(-340.795 -295.155)'
        fill='#4c6085'
      />
      <path
        id='Path_3592'
        data-name='Path 3592'
        d='M425.958,316.773h2.031v5.089h-2.031Z'
        transform='translate(-399.562 -295.155)'
        fill='#4c6085'
      />
      <path
        id='Path_3593'
        data-name='Path 3593'
        d='M199.959,321.606h7.531V324.2h-7.531Z'
        transform='translate(-187.04 -298.645)'
        fill='#4c6085'
      />
    </g>
  </svg>
);

export const IconHome = () => (
  <svg
    id='home'
    xmlns='http://www.w3.org/2000/svg'
    width='33.129'
    height='32.132'
    viewBox='0 0 33.129 32.132'>
    <g id='home_1_' data-name='home (1)' transform='translate(0)'>
      <g id='Group_1020' data-name='Group 1020' transform='translate(0)'>
        <path
          id='Path_3839'
          data-name='Path 3839'
          d='M32.573,26.951l-2.8-2.6V15.72a.984.984,0,0,0-.974-.994H22.063a.984.984,0,0,0-.974.994v.553l-3.38-3.143a1.666,1.666,0,0,0-2.288,0L.556,26.951a1.747,1.747,0,0,0-.44,1.907A1.689,1.689,0,0,0,1.7,29.966H4.075V43.813a.984.984,0,0,0,.974.994H13.2a.984.984,0,0,0,.974-.994V35.406h4.788v8.408a.984.984,0,0,0,.974.994H28.08a.984.984,0,0,0,.974-.994V29.966h2.374a1.689,1.689,0,0,0,1.584-1.107A1.747,1.747,0,0,0,32.573,26.951ZM28.08,27.978a.984.984,0,0,0-.974.994V42.819h-6.2V34.412a.984.984,0,0,0-.974-.994H13.2a.984.984,0,0,0-.974.994v8.408h-6.2V28.972a.984.984,0,0,0-.974-.994h-2.7L16.565,14.757l4.842,4.5a.96.96,0,0,0,1.05.175,1,1,0,0,0,.581-.909v-1.81h4.788v8.074a1,1,0,0,0,.318.735l2.64,2.455Z'
          transform='translate(0 -12.675)'
          fill='#4c6085'
        />
      </g>
    </g>
  </svg>
);

export const IconEyeOn = () => (
  <svg className='icon-password' viewBox='0 0 24 24'>
    <path d='M12 13.5c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5m0-5c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5m.22 8.498c-4.306.1-7.115-3.583-8.047-5.002 1.026-1.605 3.61-4.891 7.608-4.993 4.289-.11 7.114 3.583 8.046 5.002-1.025 1.605-3.61 4.89-7.607 4.993m9.648-5.495c-.638-1.112-4.162-6.686-10.138-6.5-5.528.14-8.743 5.01-9.597 6.5a.999.999 0 0 0 0 .995C2.762 13.595 6.162 19 12.025 19l.246-.003c5.527-.141 8.743-5.01 9.597-6.5a1.004 1.004 0 0 0 0-.994' />
  </svg>
);

export const IconCollections = () => (
  <svg className='icon-menu' viewBox='0 0 24 24'>
    <path d='M18.74 7.986a.782.782 0 0 0-.188-.097 7.729 7.729 0 0 0-2.299-2.306c-.013-.009-.027-.016-.04-.024A7.716 7.716 0 0 0 9.714 2C5.46 2 2 5.46 2 9.715a7.716 7.716 0 0 0 3.556 6.495 7.771 7.771 0 0 0 2.315 2.328c.022.055.05.109.085.16A7.726 7.726 0 0 0 14.286 22a7.69 7.69 0 0 0 4.15-1.211.781.781 0 1 0-.841-1.316 6.148 6.148 0 0 1-6.134.277c.198.015.398.023.598.023 4.254 0 7.714-3.46 7.714-7.714 0-.2-.008-.4-.023-.597a6.15 6.15 0 0 1-.015 5.682.781.781 0 1 0 1.382.727A7.734 7.734 0 0 0 22 14.285a7.732 7.732 0 0 0-3.26-6.299zM3.564 9.715a6.16 6.16 0 0 1 6.152-6.152 6.16 6.16 0 0 1 6.152 6.152 6.16 6.16 0 0 1-6.152 6.152 6.16 6.16 0 0 1-6.152-6.152zm8.496 8.496a6.139 6.139 0 0 1-3.07-.816c.239.023.48.035.726.035 4.254 0 7.715-3.461 7.715-7.715 0-.243-.012-.484-.034-.721a6.16 6.16 0 0 1-5.337 9.217zm-1.582-8.516a.781.781 0 1 1-1.563 0 .781.781 0 0 1 1.563 0zm3.125 0A3.91 3.91 0 0 0 9.695 5.79 3.91 3.91 0 0 0 5.79 9.695a3.91 3.91 0 0 0 3.906 3.907 3.91 3.91 0 0 0 3.907-3.907zM9.695 12.04a2.346 2.346 0 0 1-2.343-2.344 2.346 2.346 0 0 1 2.343-2.343 2.346 2.346 0 0 1 2.344 2.343 2.346 2.346 0 0 1-2.344 2.344z' />
  </svg>
);

export const IconDashboard = () => (
  <svg className='icon-menu' viewBox='0 0 24 24'>
    <path d='M2.8 13h6.8a.8.8 0 0 1 .8.8v6.8a.8.8 0 0 1-.8.8H2.8a.8.8 0 0 1-.8-.8v-6.8a.8.8 0 0 1 .8-.8zm0-11h6.8a.8.8 0 0 1 .8.8v6.8a.8.8 0 0 1-.8.8H2.8a.8.8 0 0 1-.8-.8V2.8a.8.8 0 0 1 .8-.8zm11 0h6.8a.8.8 0 0 1 .8.8v6.8a.8.8 0 0 1-.8.8h-6.8a.8.8 0 0 1-.8-.8V2.8a.8.8 0 0 1 .8-.8zm0 11h6.8a.8.8 0 0 1 .8.8v6.8a.8.8 0 0 1-.8.8h-6.8a.8.8 0 0 1-.8-.8v-6.8a.8.8 0 0 1 .8-.8zm.65 1.45v5.5h5.5v-5.5h-5.5zm0-11v5.5h5.5v-5.5h-5.5zm-11 0v5.5h5.5v-5.5h-5.5zm0 11v5.5h5.5v-5.5h-5.5z' />
  </svg>
);

export const IconOrder = () => (
  <svg className='icon-menu' viewBox='0 0 24 24'>
    <path d='M9.591 16.464h2.921v1.719h-2.92v-1.719zM6.37 16.25a1.074 1.074 0 1 0 0 2.147 1.074 1.074 0 0 0 0-2.147zm11.899-5.241H9.59v1.718h8.678V11.01zm-11.9-.215a1.074 1.074 0 1 0 0 2.148 1.074 1.074 0 0 0 0-2.148zm11.9-4.94H9.59v1.718h8.678V5.854zm-11.9-.215a1.074 1.074 0 1 0 0 2.148 1.074 1.074 0 0 0 0-2.148zM2.72 20.417V3.577a.86.86 0 0 1 .858-.859h16.84a.86.86 0 0 1 .859.86v9.708h1.718V3.577A2.58 2.58 0 0 0 20.417 1H3.577A2.58 2.58 0 0 0 1 3.577v16.84a2.58 2.58 0 0 0 2.577 2.577H13.5v-1.718H3.577a.86.86 0 0 1-.859-.86zM21.784 23l-1.711-1.711a3.842 3.842 0 0 1-1.977.545 3.87 3.87 0 0 1-3.866-3.866 3.87 3.87 0 0 1 3.866-3.866 3.87 3.87 0 0 1 3.866 3.866c0 .789-.238 1.523-.645 2.135L23 21.785 21.785 23zm-3.688-2.884a2.15 2.15 0 0 0 2.148-2.148 2.15 2.15 0 0 0-2.148-2.148 2.15 2.15 0 0 0-2.148 2.148 2.15 2.15 0 0 0 2.148 2.148z' />
  </svg>
);

export const IconPins = () => (
  <svg className='icon-menu' viewBox='0 0 24 24'>
    <path d='M15.035 22.043h-6.07a.895.895 0 0 1-.907-.88v-2.945L5.445 19.71c-.207.117-.835.3-1.244-.314l-3.075-5.082a.87.87 0 0 1 .323-1.209l2.77-1.583-2.77-1.584a.873.873 0 0 1-.323-1.208L4.2 3.648c.121-.2.575-.659 1.244-.314l2.613 1.492V1.88c0-.488.409-.881.907-.881h6.07c.503 0 .907.397.907.881v2.945l2.613-1.492a.909.909 0 0 1 1.244.314l3.075 5.082a.87.87 0 0 1-.323 1.208l-2.77 1.584 2.77 1.583c.431.249.575.79.323 1.209L19.8 19.396c-.121.2-.588.654-1.244.314l-2.613-1.492v2.944a.892.892 0 0 1-.907.881zm-5.159-1.762h4.252v-3.607a.88.88 0 0 1 .458-.768.93.93 0 0 1 .912.004l3.2 1.828 2.156-3.564-3.323-1.898a.876.876 0 0 1-.449-.759c0-.31.171-.602.45-.759l3.322-1.897-2.155-3.564-3.201 1.828a.93.93 0 0 1-.912.004.88.88 0 0 1-.458-.768V2.762H9.876V6.37a.88.88 0 0 1-.458.768.93.93 0 0 1-.911-.005L5.306 5.306 3.15 8.869l3.322 1.898c.278.157.449.45.449.76 0 .309-.17.601-.449.758l-3.322 1.898 2.155 3.564 3.2-1.828a.93.93 0 0 1 .912-.004.88.88 0 0 1 .458.767v3.6z' />
  </svg>
);

export const IconSettings = () => (
  <svg className='icon-menu' viewBox='0 0 24 24'>
    <path d='M20.976 9.9l-1.404-.238a7.927 7.927 0 0 0-.564-1.362l.828-1.157a1.232 1.232 0 0 0-.134-1.592l-1.245-1.245a1.226 1.226 0 0 0-1.588-.133L15.708 5a7.844 7.844 0 0 0-1.412-.581l-.234-1.387A1.234 1.234 0 0 0 12.842 2h-1.76c-.605 0-1.119.435-1.22 1.032l-.241 1.42a7.731 7.731 0 0 0-1.358.573l-1.15-.827c-.208-.15-.459-.23-.718-.23-.33 0-.643.13-.873.363l-1.25 1.245a1.237 1.237 0 0 0-.133 1.592l.836 1.174c-.23.439-.414.894-.556 1.366l-1.387.234c-.597.1-1.032.614-1.032 1.22v1.76c0 .605.435 1.119 1.032 1.22l1.42.241c.147.468.339.924.573 1.358l-.823 1.145a1.232 1.232 0 0 0 .133 1.592l1.246 1.245a1.226 1.226 0 0 0 1.587.134l1.174-.836c.422.221.865.401 1.32.543l.234 1.404c.1.597.614 1.032 1.22 1.032h1.763c.606 0 1.12-.435 1.22-1.032l.239-1.404A7.927 7.927 0 0 0 15.7 19l1.157.827c.209.15.46.23.718.23.33 0 .64-.13.874-.363l1.245-1.245a1.237 1.237 0 0 0 .133-1.592L19 15.695a7.87 7.87 0 0 0 .564-1.362l1.404-.234A1.234 1.234 0 0 0 22 12.88V11.12a1.22 1.22 0 0 0-1.024-1.22zm-.096 2.98c0 .054-.037.1-.092.108l-1.754.292a.56.56 0 0 0-.452.414 6.688 6.688 0 0 1-.727 1.75.565.565 0 0 0 .025.615l1.032 1.454a.114.114 0 0 1-.012.142L17.655 18.9a.106.106 0 0 1-.08.033.103.103 0 0 1-.062-.02l-1.45-1.033a.565.565 0 0 0-.614-.025 6.688 6.688 0 0 1-1.75.727.555.555 0 0 0-.414.452l-.297 1.754a.108.108 0 0 1-.109.092H11.12a.108.108 0 0 1-.108-.092l-.293-1.754a.56.56 0 0 0-.413-.452 6.945 6.945 0 0 1-1.713-.702.578.578 0 0 0-.284-.075.55.55 0 0 0-.326.105L6.52 18.95a.124.124 0 0 1-.063.02.112.112 0 0 1-.08-.033l-1.245-1.245a.113.113 0 0 1-.012-.142l1.028-1.441a.572.572 0 0 0 .025-.618 6.625 6.625 0 0 1-.736-1.747.572.572 0 0 0-.45-.413L3.22 13.03a.108.108 0 0 1-.092-.109v-1.759c0-.054.038-.1.092-.108l1.742-.293a.565.565 0 0 0 .456-.418 6.681 6.681 0 0 1 .714-1.754.558.558 0 0 0-.03-.61l-1.04-1.463a.114.114 0 0 1 .013-.142L6.32 5.13a.106.106 0 0 1 .08-.033c.024 0 .045.008.062.02l1.441 1.029c.184.13.427.137.619.025a6.625 6.625 0 0 1 1.746-.736.572.572 0 0 0 .414-.45l.3-1.768a.108.108 0 0 1 .11-.092h1.758c.054 0 .1.037.109.092l.292 1.742c.038.221.2.401.418.455.63.16 1.233.406 1.792.736.193.113.43.104.615-.025l1.44-1.036a.124.124 0 0 1 .064-.021c.016 0 .05.004.079.033l1.245 1.245a.113.113 0 0 1 .013.142l-1.032 1.45a.565.565 0 0 0-.025.614c.325.547.568 1.136.726 1.75.055.218.234.38.452.414l1.754.297a.108.108 0 0 1 .092.108v1.76h-.004zm-8.878-5.198a4.319 4.319 0 0 0-4.316 4.316 4.319 4.319 0 0 0 4.316 4.316 4.319 4.319 0 0 0 4.316-4.316 4.319 4.319 0 0 0-4.316-4.316zm0 7.504a3.19 3.19 0 0 1-3.188-3.188 3.19 3.19 0 0 1 3.188-3.188 3.19 3.19 0 0 1 3.188 3.188 3.19 3.19 0 0 1-3.188 3.188z' />
  </svg>
);

export const IconTerritoryPartner = () => (
  <svg className='icon-menu' viewBox='0 0 24 24'>
    <path d='M22 5H2v6.699h1.4a1.618 1.618 0 0 0 .155 2.197c.318.303.73.466 1.146.487.023.398.194.79.512 1.092.318.303.728.466 1.146.487.022.398.193.79.511 1.092.584.556 1.458.63 2.116.27.085.19.208.366.37.52.685.653 1.8.653 2.486 0l.158-.151.007.006a1.81 1.81 0 0 0 2.465 0l.017-.016c.145-.137.262-.295.346-.466a1.826 1.826 0 0 0 2.287-.163c.31-.294.49-.68.512-1.092a1.792 1.792 0 0 0 1.146-.487c.318-.303.488-.694.51-1.091a1.785 1.785 0 0 0 1.147-.488c.632-.602.68-1.543.157-2.197H22V5zM4.384 13.107a.54.54 0 0 1 0-.79l.649-.618h.671l.495.468-.986.94a.606.606 0 0 1-.829 0zm1.657 1.579a.54.54 0 0 1 0-.79l.987-.94.829.79-.987.94a.608.608 0 0 1-.829 0zm2.486 1.579a.606.606 0 0 1-.828 0 .54.54 0 0 1 0-.79l.987-.94.828.79-.987.94zm2.486.79a.608.608 0 0 1-.828 0 .54.54 0 0 1-.002-.789l.16-.152.828.79-.158.15zm8.595-3.948a.607.607 0 0 1-.828 0l-3.214-3.062-.829.79 3.214 3.061a.54.54 0 0 1 0 .79.608.608 0 0 1-.829 0l-3.214-3.062-.828.789 3.214 3.062a.54.54 0 0 1 0 .79.608.608 0 0 1-.829 0l-3.214-3.062-.829.79 2.238 2.131a.523.523 0 0 1 .003.768l-.018.017a.594.594 0 0 1-.81 0c-3.065-2.917-3.608-3.444-6.648-6.327H3.172V6.116h5.092L5.627 8.63 6.87 9.813a1.819 1.819 0 0 0 2.486 0l1.428-1.36a5.238 5.238 0 0 0 5.173.385l3.651 3.48a.54.54 0 0 1 0 .789zm1.22-2.525h-1.383l-3.303-3.146-.396.235c-1.446.862-3.343.705-4.614-.382l-.414-.353-2.19 2.088a.606.606 0 0 1-.83 0l-.414-.395 2.638-2.513h10.906v4.466z' />
  </svg>
);

export const IconTransaction = () => (
  <svg className='icon-menu' viewBox='0 0 24 24'>
    <path d='M20.33 8.55h-2.035V5.679c0-.92-.749-1.67-1.67-1.67H3.67c-.921 0-1.67.75-1.67 1.67v7.492c0 .92.749 1.67 1.67 1.67h2.035v2.872c0 .921.749 1.67 1.67 1.67H20.33c.921 0 1.67-.749 1.67-1.67v-7.491c0-.921-.749-1.67-1.67-1.67zM2.954 5.679c0-.394.321-.715.716-.715h12.955c.395 0 .716.32.716.715v.666H2.954v-.666zm2.75 4.543v3.664H3.67a.716.716 0 01-.716-.715V9.508h2.911c-.103.216-.16.458-.16.713zm-2.75-1.667V7.298h14.387v1.253H7.375c-.033 0-.065.001-.096.003H2.954zm17.376 9.874H7.375a.716.716 0 01-.716-.716v-7.491c0-.375.29-.683.657-.713h10.502a.475.475 0 00.052-.003h2.46c.395 0 .716.321.716.716v7.491a.716.716 0 01-.716.716zm-5.04-6.761c-.543 0-1.042.19-1.436.505a2.302 2.302 0 00-3.739 1.795 2.302 2.302 0 003.74 1.794c.393.316.892.505 1.434.505 1.269 0 2.3-1.031 2.3-2.3 0-1.268-1.031-2.3-2.3-2.3zm-2.042 3.356a1.347 1.347 0 01-2.178-1.057 1.347 1.347 0 012.178-1.057 2.284 2.284 0 000 2.114zm2.041.29a1.347 1.347 0 01-1.345-1.347c0-.741.604-1.345 1.345-1.345.742 0 1.346.604 1.346 1.345 0 .742-.604 1.346-1.346 1.346z' />
  </svg>
);

export const IconWallet = () => (
  <svg className='icon-menu' viewBox='0 0 24 24'>
    <path d='M2 6.267v9.636c0 1.563 1.314 2.834 2.93 2.834H22V4H4.344C3.05 4 2 5.017 2 6.267zm18.828 7.935H17.04l-.781-1.133.781-1.134h3.788v2.267zm0-3.4h-4.415l-1.563 2.267 1.563 2.267h4.415v2.267H4.93c-.97 0-1.758-.763-1.758-1.7V8.229a2.39 2.39 0 0 0 1.172.305h16.484v2.268zm0-3.401H4.344c-.646 0-1.172-.509-1.172-1.134 0-.625.526-1.133 1.172-1.133h16.484V7.4zm-3.039 5.02h1.053v1.053H17.79V12.42z' />
  </svg>
);

export const IconContact = () => (
  <svg className='icon-menu' viewBox='0 0 24 24'>
    <path d='M21.15 17.667l-3.9-3.9a1.196 1.196 0 00-1.689 0l-1.014 1.014a1.195 1.195 0 00-.302 1.176l-.383.383c-.272.272-1.964-.146-4.01-2.191-2.046-2.046-2.464-3.738-2.192-4.01l.383-.384a1.2 1.2 0 001.176-.302l1.014-1.014a1.195 1.195 0 000-1.689l-3.9-3.9a1.186 1.186 0 00-.845-.35c-.319 0-.618.124-.844.35L3.63 3.864a1.195 1.195 0 00-.303 1.176s-.324.327-.34.348c-1.08 1.2-1.282 3.088-.566 5.345.7 2.21 2.21 4.553 4.252 6.594 2.041 2.042 4.383 3.552 6.594 4.252.888.282 1.719.421 2.473.421 1.237 0 2.268-.375 3.008-1.114l.212-.213a1.199 1.199 0 001.176-.303l1.015-1.014a1.195 1.195 0 000-1.689zM5.489 3.694l3.9 3.9L8.376 8.61l-.015-.015L6.424 6.66l-1.95-1.95 1.014-1.015zm12.415 16.347c-.859.86-2.377 1.001-4.275.4-2.032-.644-4.202-2.05-6.11-3.958-1.91-1.909-3.315-4.079-3.959-6.11-.601-1.898-.46-3.417.4-4.276l.107-.108 3.027 3.027-.277.278c-1.151 1.152.231 3.739 2.191 5.699 1.467 1.467 3.285 2.61 4.59 2.61.439 0 .82-.129 1.11-.419l.277-.277 3.027 3.027-.108.107zm1.39-.515l-3.902-3.9 1.015-1.015 3.9 3.9-1.014 1.015zM17.267 6.732A5.875 5.875 0 0119 10.912a.587.587 0 01-1.174 0 4.707 4.707 0 00-1.388-3.35 4.707 4.707 0 00-3.35-1.388.587.587 0 010-1.174c1.578 0 3.063.615 4.18 1.732zM19.39 4.61A8.853 8.853 0 0122 10.912a.589.589 0 01-1.177 0 7.684 7.684 0 00-2.265-5.47 7.684 7.684 0 00-5.47-2.265.589.589 0 010-1.177c2.38 0 4.619.927 6.302 2.61zm-4.244 4.244A2.86 2.86 0 0116 10.916a.584.584 0 01-1.167 0c0-.474-.177-.901-.512-1.236a1.693 1.693 0 00-1.237-.513.584.584 0 010-1.167c.79 0 1.503.295 2.062.854z' />
  </svg>
);

export const IconHelp = () => (
  <svg className='icon-menu' viewBox='0 0 24 24'>
    <path d='M14.364 5.613c-.4-.42-1.024-.662-1.71-.662-1.228 0-2.325.784-2.446 1.75-.055.442.092.87.412 1.206.393.413 1.011.65 1.695.65 1.26 0 2.34-.768 2.46-1.749a1.453 1.453 0 00-.411-1.195zm-.572 1.088c-.062.503-.739.929-1.477.929-.396 0-.753-.127-.955-.34a.573.573 0 01-.168-.482c.062-.495.745-.93 1.461-.93.399 0 .761.132.97.352a.574.574 0 01.169.47zm-.006 8.7c-.117-.078-.39-.261-.17-1.533l.063-.289c.078-.363.224-1.038.383-1.791l.001-.005c.162-.814.034-1.526-.37-2.06-.366-.481-.944-.776-1.629-.83-1.012-.081-2.07.521-2.395 1.114a.576.576 0 00-.022.58c.07.13.172.202.247.255.115.081.384.272.129 1.54-.024.117-.381 1.926-.428 2.182l-.001.006c-.14.817-.002 1.532.424 2.048.687.831 1.731.792 1.772.792.974 0 1.947-.603 2.243-1.18a.576.576 0 00.007-.581.743.743 0 00-.254-.248zm-.64-3.803a339.388 339.388 0 01-.45 2.1v.005c-.238 1.362.002 1.958.342 2.292a1.84 1.84 0 01-.378.253c-.31.16-.653.242-.942.227-.422-.023-.757-.175-.968-.439-.247-.308-.328-.76-.234-1.306.05-.276.408-2.086.423-2.158v-.005c.274-1.355.05-1.957-.282-2.299a1.84 1.84 0 01.385-.243c.314-.151.66-.225.948-.202.42.033.751.194.956.463.238.315.307.768.2 1.312zm6.808 4.96C21.275 14.989 22 13.047 22 11.065c0-2.43-1.046-4.711-2.945-6.425C17.168 2.937 14.663 2 12 2c-2.663 0-5.168.937-7.055 2.64C3.045 6.352 2 8.634 2 11.063c0 2.43 1.046 4.711 2.945 6.425 1.887 1.702 4.392 2.64 7.055 2.64 1.665 0 3.306-.377 4.76-1.092l3.486 1.293a.483.483 0 00.494-.095.473.473 0 00.135-.48l-.921-3.196zm-3.055 1.515a.484.484 0 00-.39.024A9.842 9.842 0 0112 19.177c-4.985 0-9.04-3.64-9.04-8.113 0-4.473 4.055-8.113 9.04-8.113 4.985 0 9.04 3.64 9.04 8.113 0 1.861-.684 3.613-1.979 5.064a.472.472 0 00-.102.446l.732 2.535-2.792-1.036z' />
  </svg>
);

export const IconMenu = () => (
  <svg className='main-menu' viewBox='0 0 24 24'>
    <path d='M2 5h20v2H2V5zm0 6h20v2H2v-2zm0 6h20v2H2v-2z' />
  </svg>
);

export const FullLogo = () => (
  <svg className='icon-logo' viewBox='0 0 736 149'>
    <path
      className='prefix__st0'
      d='M.8 55.9V53v2.9zM43.8 51.6C43.8 23.5 66.6.7 94.7.7c27.1 0 49.3 21.2 50.8 48 .1.9.1 1.9.1 2.9v83.1c0 5.8-4.7 10.6-10.6 10.6-2.9 0-5.6-1.2-7.5-3.1-1.9-1.9-3.1-4.6-3.1-7.5V51.6c0-16.4-13.3-29.7-29.7-29.7S64.9 35.2 64.9 51.6v.2c.1 16.3 13.4 29.5 29.7 29.5h5.4c5.8 0 10.6 4.7 10.6 10.6 0 2.9-1.2 5.6-3.1 7.5-1.9 1.9-4.6 3.1-7.5 3.1h-6.5c-27.5-.6-49.6-23-49.7-50.6v-.3zM43.2 55.9l-.1-2.9c0 1 0 1.9.1 2.9zM95.1 2.1H94h1.1zM64.2 52.4V53v-.6z'
    />
    <path
      className='prefix__st0'
      d='M100.2 126.1h-5.4C54.5 126 21.9 93.3 21.9 53V11.4C21.9 5.6 17.2.8 11.3.8 5.5.8.8 5.5.8 11.4v44.5c1.5 50.4 42.5 90.8 93.1 91.4H95c2.7 0 5.4-.1 8.1-.3 1.8-.5 3.5-1.5 4.8-2.8 2.1-2.1 3.3-5 3.1-8.2-.4-5.6-5.2-9.9-10.8-9.9zM195.5 64v17.1h6.7v4h-11.8V64h5.1zM219.2 85.3c-6 0-10.8-4.5-10.8-10.8 0-6.3 4.9-10.8 10.8-10.8 6 0 10.8 4.4 10.8 10.8 0 6.3-4.8 10.8-10.8 10.8zm0-4.7c3.4 0 5.5-2.4 5.5-6.1 0-3.8-2.2-6.1-5.5-6.1-3.4 0-5.6 2.4-5.6 6.1 0 3.7 2.2 6.1 5.6 6.1zM247 63.8c5 0 8.8 2.8 10 7.4h-5.6c-.9-1.8-2.5-2.7-4.4-2.7-3.1 0-5.3 2.3-5.3 6.1 0 3.7 2.2 6.1 5.3 6.1 2 0 3.5-.9 4.4-2.7h5.6c-1.2 4.6-5 7.3-10 7.3-6.2 0-10.6-4.4-10.6-10.7 0-6.4 4.4-10.8 10.6-10.8zM277.8 81.4h-7.9l-1.3 3.7h-5.4l7.6-21.1h5.9l7.6 21.1H279l-1.2-3.7zm-4-11.7l-2.6 7.7h5.2l-2.6-7.7zM296.4 64v17.1h6.7v4h-11.8V64h5.1zM340.6 70.7h-5.7c-.8-1.4-2.2-2.2-4.1-2.2-3.3 0-5.5 2.3-5.5 6 0 3.9 2.2 6.2 5.9 6.2 2.5 0 4.3-1.3 5.1-3.7h-6.5v-3.8H341V78c-1.1 3.6-4.6 7.3-10.1 7.3-6.3 0-10.7-4.4-10.7-10.7 0-6.3 4.4-10.7 10.7-10.7 4.9-.1 8.6 2.5 9.7 6.8zM358.3 85.3c-6 0-10.8-4.5-10.8-10.8 0-6.3 4.9-10.8 10.8-10.8 6 0 10.8 4.4 10.8 10.8-.1 6.3-4.9 10.8-10.8 10.8zm0-4.7c3.4 0 5.6-2.4 5.6-6.1 0-3.8-2.2-6.1-5.6-6.1-3.4 0-5.6 2.4-5.6 6.1 0 3.7 2.1 6.1 5.6 6.1zM390.7 64h5.4l-7.5 21.1h-6.4L374.8 64h5.5l5.2 15.9 5.2-15.9zM415.7 68.1h-7.8v4.3h6.9v4h-6.9V81h7.8v4.1h-12.9V64h12.9v4.1zM432.1 64c5.2 0 7.7 3 7.7 6.6 0 2.6-1.4 5.1-4.7 6.1L440 85h-5.8l-4.4-7.9h-1.2V85h-5.1V64h8.6zm-.3 4.3h-3.2v5.2h3.2c1.9 0 2.8-1 2.8-2.6s-.9-2.6-2.8-2.6zM466.4 64v21.1h-5.1l-8.6-13v13h-5.1V64h5.1l8.6 13.1V64h5.1zM474.6 64h6.1l5.9 14.6 5.8-14.6h6v21.1h-5.1V72.4L488.6 85h-4.1l-4.7-12.7V85h-5.1V64zM519.6 68.1h-7.8v4.3h6.9v4h-6.9V81h7.8v4.1h-12.9V64h12.9v4.1zM546.2 64v21.1h-5.1l-8.6-13v13h-5.1V64h5.1l8.6 13.1V64h5.1zM553.3 64h16.3v4.1H564V85h-5.1V68.1h-5.6V64zM595.2 85.3c-4.5 0-8.1-2.2-8.2-6.5h5.5c.2 1.6 1.2 2.4 2.6 2.4 1.5 0 2.5-.8 2.5-2 0-3.9-10.5-1.8-10.5-9.3 0-4 3.3-6.2 7.7-6.2 4.6 0 7.7 2.3 7.9 6.3H597c-.1-1.3-1.1-2.2-2.4-2.2-1.2 0-2.2.6-2.2 1.9 0 3.7 10.4 2 10.4 9.1 0 3.5-2.7 6.5-7.6 6.5zM608.9 64h5.8l4.1 8.8 4.1-8.8h5.8l-7.3 14.1v7h-5.1v-7L608.9 64zM642.8 85.3c-4.5 0-8.1-2.2-8.2-6.5h5.5c.2 1.6 1.2 2.4 2.6 2.4 1.5 0 2.5-.8 2.5-2 0-3.9-10.5-1.8-10.5-9.3 0-4 3.3-6.2 7.7-6.2 4.6 0 7.7 2.3 7.9 6.3h-5.5c-.1-1.3-1.1-2.2-2.4-2.2-1.2 0-2.2.6-2.2 1.9 0 3.7 10.4 2 10.4 9.1-.2 3.5-2.9 6.5-7.8 6.5zM656.9 64h16.3v4.1h-5.6V85h-5.1V68.1h-5.6V64zM693.2 68.1h-7.8v4.3h6.9v4h-6.9V81h7.8v4.1h-12.9V64h12.9v4.1zM701 64h6.1l5.9 14.6 5.9-14.6h6v21.1h-5.1V72.4L715 85.1h-4.1l-4.7-12.7v12.7H701V64z'
    />
  </svg>
);

export const IconProfile = () => (
  <svg className='icon-menu' viewBox='0 0 24 24'>
    <path d='M17.071 2.929A9.935 9.935 0 0010 0a9.935 9.935 0 00-7.071 2.929A9.935 9.935 0 000 10a9.935 9.935 0 002.929 7.071A9.935 9.935 0 0010 20a9.935 9.935 0 007.071-2.929A9.935 9.935 0 0020 10a9.935 9.935 0 00-2.929-7.071zm-12.73 13.84c.33-2.84 2.772-5.034 5.659-5.034 1.522 0 2.953.593 4.03 1.669a5.694 5.694 0 011.63 3.365A8.788 8.788 0 0110 18.83a8.788 8.788 0 01-5.66-2.06zM10 10.528A3.04 3.04 0 016.963 7.49 3.04 3.04 0 0110 4.453a3.04 3.04 0 013.037 3.037A3.04 3.04 0 0110 10.528zm6.669 5.25a6.871 6.871 0 00-1.81-3.203 6.85 6.85 0 00-2.502-1.599 4.208 4.208 0 001.852-3.486c0-2.32-1.888-4.209-4.209-4.209a4.208 4.208 0 00-2.355 7.696 6.854 6.854 0 00-2.327 1.428 6.849 6.849 0 00-1.987 3.373A8.79 8.79 0 011.17 10c0-4.868 3.961-8.828 8.829-8.828s8.828 3.96 8.828 8.828a8.79 8.79 0 01-2.16 5.779z' />
  </svg>
);

export const IconPermit = () => (
  <svg className='icon-menu' viewBox='0 0 24 24'>
    <path d='M9.498 21.134H.828V3.988h3.19v.797c0 .22.18.399.4.399h6.38c.22 0 .398-.179.398-.399v-.797h3.19v8.772a.399.399 0 00.798 0V3.59a.399.399 0 00-.399-.399h-3.589v-.797a.399.399 0 00-.399-.4H9.601C9.601.895 8.707 0 7.607 0 6.508 0 5.614.894 5.614 1.994H4.417a.399.399 0 00-.398.399v.797H.429a.399.399 0 00-.398.399v17.944c0 .22.179.398.399.398h9.068a.399.399 0 000-.797zM7.608.798c.66 0 1.196.536 1.196 1.196H6.41c0-.66.537-1.196 1.196-1.196zM4.815 2.79H10.4v1.595H4.816V2.791z' />
    <path d='M14.785 13.558a5.19 5.19 0 00-5.184 5.183 5.19 5.19 0 005.184 5.184 5.19 5.19 0 005.184-5.184 5.19 5.19 0 00-5.184-5.183zm0 9.57a4.391 4.391 0 01-4.386-4.387 4.391 4.391 0 014.386-4.386 4.391 4.391 0 014.386 4.386 4.391 4.391 0 01-4.386 4.387zM2.822 16.349a.399.399 0 000 .797h5.926a.399.399 0 000-.797H2.822zM10.801 13.956a.399.399 0 00-.398-.398h-7.58a.399.399 0 000 .797h7.58c.22 0 .398-.178.398-.399zM12.791 11.165a.399.399 0 00-.398-.399h-9.57a.399.399 0 000 .798h9.57c.22 0 .398-.179.398-.399zM12.393 7.975h-9.57a.399.399 0 000 .798h9.57a.399.399 0 000-.798z' />
    <path d='M17.858 16.864a.399.399 0 00-.564 0l-3.306 3.307-1.712-1.712a.399.399 0 10-.564.564l1.994 1.994a.397.397 0 00.563 0l3.59-3.589a.399.399 0 000-.564z' />
  </svg>
);

export const IconHowTo = () => (
  <svg className='icon-menu' viewBox='0 0 24 24'>
    <path d='M11.945 3.001a8.742 8.742 0 016.131 2.637 8.75 8.75 0 012.528 6.178 8.83 8.83 0 01-.91 3.888l1.235 3.597c.16.467.044.973-.306 1.323a1.273 1.273 0 01-1.323.305l-3.596-1.235a8.83 8.83 0 01-3.888.91h-.014a8.749 8.749 0 01-6.164-2.528 8.742 8.742 0 01-2.637-6.131 8.767 8.767 0 012.577-6.367 8.768 8.768 0 016.367-2.577zm-.017 1.067a7.675 7.675 0 00-5.595 2.265 7.676 7.676 0 00-2.265 5.595c.067 4.202 3.543 7.616 7.746 7.61a7.75 7.75 0 003.6-.894.533.533 0 01.422-.033l3.811 1.31a.206.206 0 00.222-.052.206.206 0 00.051-.222l-1.31-3.81a.534.534 0 01.034-.423 7.75 7.75 0 00.893-3.6c.007-4.204-3.407-7.68-7.61-7.746zm-.212 11.685c.299 0 .52.244.533.534.013.288-.254.533-.533.533-.3 0-.521-.244-.534-.533-.013-.289.254-.534.534-.534zm0-8.264a2.658 2.658 0 012.654 2.654 2.66 2.66 0 01-2.12 2.601v1.697a.534.534 0 11-1.068 0v-2.176c0-.295.239-.534.534-.534a1.59 1.59 0 001.587-1.588 1.59 1.59 0 00-1.587-1.587 1.59 1.59 0 00-1.588 1.587.534.534 0 01-1.067 0 2.658 2.658 0 012.655-2.654z' />
  </svg>
);

export const IconFAQ = () => (
  <svg className='icon-menu' viewBox='0 0 24 24'>
    <path d='M18.363 3A2.64 2.64 0 0121 5.637v12.726A2.64 2.64 0 0118.363 21H5.637A2.64 2.64 0 013 18.363V5.637A2.64 2.64 0 015.637 3zM4.055 11.149v7.214c0 .873.71 1.582 1.582 1.582h12.726c.873 0 1.582-.71 1.582-1.582v-5.836H5.672a.528.528 0 01-.37-.151l-1.247-1.227zm2.672 2.433c.872 0 1.582.71 1.582 1.582v3.164a.527.527 0 01-1.055 0v-1.195H6.199v1.195a.527.527 0 01-1.054 0v-3.164c0-.872.71-1.582 1.582-1.582zm10.546 3.164a.527.527 0 010 1.055H9.891a.527.527 0 010-1.055zm-10.546-2.11a.528.528 0 00-.528.528v.914h1.055v-.914a.528.528 0 00-.527-.527zm11.601 0a.527.527 0 010 1.055H9.891a.527.527 0 010-1.054zm.035-10.581H5.637c-.873 0-1.582.71-1.582 1.582V9.67l1.833 1.803h14.057V5.637c0-.873-.71-1.582-1.582-1.582zm-1.09 5.343a.527.527 0 110 1.055.527.527 0 010-1.055zm-4.218-1.09a.527.527 0 010 1.055H5.672a.527.527 0 010-1.054zm4.218-3.163c.873 0 1.582.71 1.582 1.582 0 .687-.44 1.274-1.054 1.491v.09a.527.527 0 01-1.055 0v-.527c0-.291.236-.527.527-.527A.528.528 0 1017 6.276a.527.527 0 11-.55-.9 1.58 1.58 0 01.824-.231zm-2.636 1.054a.527.527 0 010 1.055H5.672a.527.527 0 010-1.055z' />
  </svg>
);

export const CashIn = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='17.377'
    height='17'
    viewBox='0 0 17.377 17'>
    {/* <defs>
    <style>.a{fill:#7790cb;}</style>
  </defs> */}
    <g transform='translate(0 0)'>
      <path
        className='cashIn'
        d='M15.9,8.047h-.574l-.889-2.5-7,2.5H1.475A1.476,1.476,0,0,0,0,9.521V21.076a1.476,1.476,0,0,0,1.475,1.475H15.9a1.476,1.476,0,0,0,1.475-1.475V9.521A1.476,1.476,0,0,0,15.9,8.047ZM13.812,6.87l.419,1.177H10.51Zm2.532,14.206a.443.443,0,0,1-.442.442H1.475a.443.443,0,0,1-.442-.442V9.521a.443.443,0,0,1,.442-.442H15.9a.443.443,0,0,1,.442.442v3.564H11.382a1.476,1.476,0,0,0-1.475,1.475v1.478a1.476,1.476,0,0,0,1.475,1.475h4.962Zm0-4.6H11.382a.443.443,0,0,1-.442-.442V14.559a.443.443,0,0,1,.442-.442h4.962Z'
        transform='translate(0 -5.551)'
      />
    </g>
    <g transform='translate(11.446 9.066)'>
      <circle className='cashIn' cx='0.682' cy='0.682' r='0.682' />
    </g>
  </svg>
);

export const IconSearch = () => (
  <svg
    id='search'
    xmlns='http://www.w3.org/2000/svg'
    width='24.877'
    height='24.876'
    viewBox='0 0 24.877 24.876'>
    <g id='Group_842' data-name='Group 842'>
      <g id='Group_841' data-name='Group 841'>
        <path
          id='Path_3554'
          data-name='Path 3554'
          d='M10.955,0A10.955,10.955,0,1,0,21.91,10.955,10.968,10.968,0,0,0,10.955,0Zm0,19.888a8.933,8.933,0,1,1,8.933-8.933A8.943,8.943,0,0,1,10.955,19.888Z'
          fill='#8f9db6'
        />
      </g>
    </g>
    <g
      id='Group_844'
      data-name='Group 844'
      transform='translate(17.056 17.056)'>
      <g id='Group_843' data-name='Group 843'>
        <path
          id='Path_3555'
          data-name='Path 3555'
          d='M358.57,357.14l-5.8-5.8a1.011,1.011,0,0,0-1.43,1.43l5.8,5.8a1.011,1.011,0,0,0,1.43-1.43Z'
          transform='translate(-351.046 -351.046)'
          fill='#8f9db6'
        />
      </g>
    </g>
  </svg>
);

export const IconGovernment = () => (
  <svg
    id='government_1_'
    data-name='government (1)'
    xmlns='http://www.w3.org/2000/svg'
    width='24.31'
    height='27.039'
    viewBox='0 0 24.31 27.039'>
    <path
      id='Path_3584'
      data-name='Path 3584'
      d='M20.991,13.5V10.332H17.612A4.863,4.863,0,0,0,13,5.93H12.87V4.578h3.279V0h-4.7V5.93h-.127a4.863,4.863,0,0,0-4.615,4.4H3.325V13.5H0V27.039h24.31V13.5ZM12.87,1.585h1.854V2.993H12.87Zm-1.552,5.93H13a3.348,3.348,0,0,1,3.165,2.817H8.154a3.348,3.348,0,0,1,3.165-2.817Zm-6.569,4.4H19.566V13.5H4.75Zm8.643,13.538H10.923V22.04h2.469Zm9.5,0H14.817v-5H9.5v5H1.428V15.085h21.46Z'
      transform='translate(-0.003)'
      fill='#7790cb'
    />
    <path
      id='Path_3589'
      data-name='Path 3589'
      d='M363.959,396.441h.928v2.693h-.928Z'
      transform='translate(-346.448 -376.692)'
      fill='#7790cb'
    />
    <path
      id='Path_4158'
      data-name='Path 4158'
      d='M363.959,396.441h.928v2.693h-.928Z'
      transform='translate(-359.448 -376.692)'
      fill='#7790cb'
    />
    <path
      id='Path_3590'
      data-name='Path 3590'
      d='M425.958,396.441h.907v2.692h-.907Z'
      transform='translate(-407.394 -376.691)'
      fill='#7790cb'
    />
    <path
      id='Path_4157'
      data-name='Path 4157'
      d='M425.958,396.441h.907v2.692h-.907Z'
      transform='translate(-420.394 -376.691)'
      fill='#7790cb'
    />
    <path
      id='Path_3591'
      data-name='Path 3591'
      d='M363.959,316.773h.928v2.544h-.928Z'
      transform='translate(-346.448 -299.903)'
      fill='#7790cb'
    />
    <path
      id='Path_4156'
      data-name='Path 4156'
      d='M363.959,316.773h.928v2.544h-.928Z'
      transform='translate(-359.448 -299.903)'
      fill='#7790cb'
    />
    <path
      id='Path_3592'
      data-name='Path 3592'
      d='M425.958,316.773h.907v2.543h-.907Z'
      transform='translate(-407.394 -299.903)'
      fill='#7790cb'
    />
    <path
      id='Path_4159'
      data-name='Path 4159'
      d='M425.958,316.773h.907v2.543h-.907Z'
      transform='translate(-420.394 -299.903)'
      fill='#7790cb'
    />
    <path
      id='Path_3593'
      data-name='Path 3593'
      d='M199.959,321.606h7.531v2.839h-7.531Z'
      transform='translate(-191.536 -305.537)'
      fill='none'
      stroke='#7790cb'
    />
  </svg>
);

export const IconCustomer = () => (
  <svg
    id='customer'
    xmlns='http://www.w3.org/2000/svg'
    width='23.754'
    height='22.291'
    viewBox='0 0 23.754 22.291'>
    <g id='Group_993' data-name='Group 993' transform='translate(0 9.484)'>
      <g id='Group_992' data-name='Group 992'>
        <path
          id='Path_3610'
          data-name='Path 3610'
          d='M23.011,236.731a2.087,2.087,0,0,0-2.874.174l-2.045,2.2a2.091,2.091,0,0,0-1.994-1.469h-3.65c-.277,0-.37-.106-.851-.476a4.882,4.882,0,0,0-6.418.015l-1.342,1.181a2.079,2.079,0,0,0-1.914-.024L.385,239.1a.7.7,0,0,0-.311.934l4.175,8.351a.7.7,0,0,0,.934.311l1.539-.77a2.086,2.086,0,0,0,1.153-1.941H16.1a4.894,4.894,0,0,0,3.9-1.948l3.341-4.455A2.082,2.082,0,0,0,23.011,236.731ZM6.1,246.678l-.916.458L1.629,240.03l.917-.458a.7.7,0,0,1,.933.311l2.931,5.861A.7.7,0,0,1,6.1,246.678Zm16.124-7.934L18.882,243.2A3.5,3.5,0,0,1,16.1,244.59H7.389l-2.608-5.216L6.1,238.215a3.488,3.488,0,0,1,4.6,0,2.463,2.463,0,0,0,1.752.808H16.1a.7.7,0,1,1,0,1.392H12.544a.7.7,0,1,0,0,1.392h4.02a2.093,2.093,0,0,0,1.528-.665l3.064-3.289a.7.7,0,0,1,1.067.891Z'
          transform='translate(0 -235.959)'
          fill='#7790cb'
        />
      </g>
    </g>
    <g id='Group_995' data-name='Group 995' transform='translate(5.877 -9)'>
      <g id='Group_994' data-name='Group 994' transform='translate(3 9)'>
        <path
          id='Path_3611'
          data-name='Path 3611'
          d='M186.993,4.582a2.667,2.667,0,0,0,.741-1.846A2.715,2.715,0,0,0,185.056.013a2.759,2.759,0,0,0-2.723,2.723,2.629,2.629,0,0,0,.766,1.852,4.085,4.085,0,0,0-2.1,3.55v.67a.67.67,0,0,0,.67.67h6.74a.67.67,0,0,0,.67-.67v-.67A4.082,4.082,0,0,0,186.993,4.582Zm-1.937-3.23A1.38,1.38,0,0,1,186.4,2.736a1.341,1.341,0,0,1-1.339,1.339,1.38,1.38,0,0,1-1.384-1.339A1.42,1.42,0,0,1,185.056,1.352Zm-2.723,6.785a2.759,2.759,0,0,1,2.723-2.723,2.7,2.7,0,0,1,2.678,2.723Z'
          transform='translate(-180.994 -0.013)'
          fill='#7790cb'
        />
      </g>
    </g>
  </svg>
);

export const IconNews = () => (
  <svg
    id='icon_news'
    data-name='icon &gt; news'
    xmlns='http://www.w3.org/2000/svg'
    width='33.091'
    height='31.684'
    viewBox='0 0 33.091 31.684'>
    <g id='newspaper_1_' data-name='newspaper (1)'>
      <g id='Group_997' data-name='Group 997' transform='translate(0 0)'>
        <g id='Group_996' data-name='Group 996'>
          <path
            id='Path_3612'
            data-name='Path 3612'
            d='M32.109,10.888H.982A.982.982,0,0,0,0,11.87v29.72a.982.982,0,0,0,.982.982H32.109a.982.982,0,0,0,.982-.982V11.87A.982.982,0,0,0,32.109,10.888Zm-.982,29.72H1.964V12.852H31.127V40.608Z'
            transform='translate(0 -10.888)'
            fill='#4c6085'
          />
        </g>
      </g>
      <g id='Group_999' data-name='Group 999' transform='translate(5.38 4.033)'>
        <g id='Group_998' data-name='Group 998'>
          <path
            id='Path_3613'
            data-name='Path 3613'
            d='M86.056,73.864v1.9l-.914-1.743c-.325-.624-.545-.724-1.086-.724-.487,0-.815.232-.815.577v5.035c0,.77,1.63.771,1.63,0v-1.93l1.138,2.072a.883.883,0,0,0,.862.435c.48,0,.815-.237.815-.577V73.864C87.685,73.1,86.056,73.1,86.056,73.864Z'
            transform='translate(-83.241 -73.291)'
            fill='#4c6085'
          />
        </g>
      </g>
      <g
        id='Group_1001'
        data-name='Group 1001'
        transform='translate(10.811 4.036)'>
        <g id='Group_1000' data-name='Group 1000'>
          <path
            id='Path_3614'
            data-name='Path 3614'
            d='M170.834,78.059h-1.929V77.1h.993c.763,0,.753-1.344,0-1.344h-.993v-.947h1.929c.753,0,.767-1.471,0-1.471h-2.823c-.426,0-.735.243-.735.577v5.035c0,.334.309.577.735.577h2.823C171.6,79.53,171.587,78.059,170.834,78.059Z'
            transform='translate(-167.276 -73.341)'
            fill='#4c6085'
          />
        </g>
      </g>
      <g
        id='Group_1003'
        data-name='Group 1003'
        transform='translate(15.203 4.036)'>
        <g id='Group_1002' data-name='Group 1002'>
          <path
            id='Path_3615'
            data-name='Path 3615'
            d='M241.283,73.708l-.994,3.356-.457-1.956c-.142-.64-1.431-.636-1.572,0l-.458,1.958-.994-3.355c-.212-.743-1.8-.265-1.557.48l1.577,4.835c.236.752,1.828.721,2-.017l.22-1,.221,1.007c.165.723,1.734.779,1.995.02l1.578-4.838C243.088,73.443,241.494,72.968,241.283,73.708Z'
            transform='translate(-235.224 -73.337)'
            fill='#4c6085'
          />
        </g>
      </g>
      <g
        id='Group_1005'
        data-name='Group 1005'
        transform='translate(23.148 3.989)'>
        <g id='Group_1004' data-name='Group 1004'>
          <path
            id='Path_3616'
            data-name='Path 3616'
            d='M359.928,74.323c0-.17.234-.279.6-.279.609,0,.72.3,1.086.3.486,0,.688-.551.688-.847,0-.83-1.358-.894-1.774-.894-1.027,0-2.226.481-2.226,1.838,0,1.946,2.513,1.919,2.513,2.648,0,.318-.514.327-.573.327-.673,0-.866-.587-1.348-.587-.442,0-.736.519-.736.862,0,1.454,4.286,2.059,4.286-.729C362.442,74.9,359.928,74.861,359.928,74.323Z'
            transform='translate(-358.156 -72.604)'
            fill='#4c6085'
          />
        </g>
      </g>
      <g
        id='Group_1007'
        data-name='Group 1007'
        transform='translate(4.166 17.24)'>
        <g id='Group_1006' data-name='Group 1006'>
          <path
            id='Path_3617'
            data-name='Path 3617'
            d='M73.482,277.633H65.444a.982.982,0,0,0-.982.982V287.7a.982.982,0,0,0,.982.982h8.038a.982.982,0,0,0,.982-.982v-9.081A.982.982,0,0,0,73.482,277.633Zm-.982,9.08H66.426V279.6H72.5Z'
            transform='translate(-64.462 -277.633)'
            fill='#4c6085'
          />
        </g>
      </g>
      <g
        id='Group_1009'
        data-name='Group 1009'
        transform='translate(4.166 12.385)'>
        <g id='Group_1008' data-name='Group 1008'>
          <path
            id='Path_3618'
            data-name='Path 3618'
            d='M87.607,202.515H65.444a.982.982,0,1,0,0,1.964H87.607a.982.982,0,0,0,0-1.964Z'
            transform='translate(-64.462 -202.515)'
            fill='#4c6085'
          />
        </g>
      </g>
      <g
        id='Group_1011'
        data-name='Group 1011'
        transform='translate(17.863 17.227)'>
        <g id='Group_1010' data-name='Group 1010'>
          <path
            id='Path_3619'
            data-name='Path 3619'
            d='M285.813,277.433h-8.447a.982.982,0,0,0,0,1.964h8.447a.982.982,0,0,0,0-1.964Z'
            transform='translate(-276.384 -277.433)'
            fill='#4c6085'
          />
        </g>
      </g>
      <g
        id='Group_1013'
        data-name='Group 1013'
        transform='translate(17.863 21.459)'>
        <g id='Group_1012' data-name='Group 1012'>
          <path
            id='Path_3620'
            data-name='Path 3620'
            d='M285.813,342.913h-8.447a.982.982,0,0,0,0,1.964h8.447a.982.982,0,0,0,0-1.964Z'
            transform='translate(-276.384 -342.913)'
            fill='#4c6085'
          />
        </g>
      </g>
      <g
        id='Group_1015'
        data-name='Group 1015'
        transform='translate(17.863 25.691)'>
        <g id='Group_1014' data-name='Group 1014'>
          <path
            id='Path_3621'
            data-name='Path 3621'
            d='M285.813,408.393h-8.447a.982.982,0,1,0,0,1.964h8.447a.982.982,0,0,0,0-1.964Z'
            transform='translate(-276.384 -408.393)'
            fill='#4c6085'
          />
        </g>
      </g>
    </g>
  </svg>
);

export const IconGrocery = () => (
  <svg
    id='Group_1593'
    data-name='Group 1593'
    xmlns='http://www.w3.org/2000/svg'
    width='27.149'
    height='22.916'
    viewBox='0 0 27.149 22.916'>
    <path
      id='Path_3602'
      data-name='Path 3602'
      d='M7.584,53.322H23.173a.8.8,0,0,0,.771-.567l3.173-10.513a.786.786,0,0,0-.126-.7.808.808,0,0,0-.645-.319H5.875L4.792,37.634a.8.8,0,0,0-.771-.567H.8a.794.794,0,1,0,0,1.588H3.422L4.5,42.224c0,.012.007.023.011.035l2.862,9.483a3.1,3.1,0,0,0,.213,6.194h.8a2.888,2.888,0,0,0,5.525,0h4.268a2.888,2.888,0,0,0,5.525,0h1.036a.794.794,0,1,0,0-1.588H23.7a2.888,2.888,0,0,0-5.525,0H13.908a2.888,2.888,0,0,0-5.525,0h-.8a1.513,1.513,0,1,1,0-3.026Zm11.8-10.513h5.883l-1.107,3.669H19.384Zm0,5.257h4.3l-1.107,3.669H19.384Zm-5.952-5.257h4.343v3.669H13.432V42.809Zm0,5.257h4.343v3.669H13.432Zm-1.609,3.669H9.047L7.94,48.066h3.883ZM6.354,42.809h5.469v3.669H7.461ZM20.938,55.89a1.253,1.253,0,1,1-1.269,1.253A1.262,1.262,0,0,1,20.938,55.89Zm-9.793,0a1.253,1.253,0,1,1-1.269,1.253A1.262,1.262,0,0,1,11.145,55.89Z'
      transform='translate(0 -37.067)'
      fill='#7790cb'
    />
  </svg>
);

export const IconReceipt = () => (
  <svg
    id='receipt'
    xmlns='http://www.w3.org/2000/svg'
    width='19.322'
    height='24.014'
    viewBox='0 0 19.322 24.014'>
    <g id='Group_977' data-name='Group 977' transform='translate(0)'>
      <g id='Group_976' data-name='Group 976'>
        <path
          id='Path_3605'
          data-name='Path 3605'
          d='M59.738,1.822,57.356.406,54.973,1.822,52.59.406,50.207,1.822,47.142,0V18.883H43.481v2.538a2.557,2.557,0,0,0,2.513,2.593h14.3A2.557,2.557,0,0,0,62.8,21.421V0ZM45.994,22.606a1.168,1.168,0,0,1-1.148-1.185v-1.13H57.777v1.13a2.644,2.644,0,0,0,.278,1.185Zm14.3,0a1.168,1.168,0,0,1-1.148-1.185V18.883H48.507V2.436l1.7,1.011L52.59,2.031l2.383,1.416,2.383-1.416,2.383,1.416,1.7-1.011V21.421h0A1.168,1.168,0,0,1,60.29,22.606Z'
          transform='translate(-43.481)'
          fill='#7790cb'
        />
      </g>
    </g>
    <g id='Group_979' data-name='Group 979' transform='translate(5.963 6.295)'>
      <g id='Group_978' data-name='Group 978'>
        <rect
          id='Rectangle_299'
          data-name='Rectangle 299'
          width='10.12'
          height='1.62'
          fill='#7790cb'
        />
      </g>
    </g>
    <g id='Group_981' data-name='Group 981' transform='translate(5.859 8.955)'>
      <g id='Group_980' data-name='Group 980' transform='translate(0)'>
        <rect
          id='Rectangle_300'
          data-name='Rectangle 300'
          width='10.224'
          height='1.62'
          fill='#7790cb'
        />
      </g>
    </g>
    <g id='Group_983' data-name='Group 983' transform='translate(5.963 11.615)'>
      <g id='Group_982' data-name='Group 982'>
        <rect
          id='Rectangle_301'
          data-name='Rectangle 301'
          width='6.053'
          height='1.62'
          fill='#7790cb'
        />
      </g>
    </g>
  </svg>
);

export const IconGoManila = (props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={35}
      height={35}
      viewBox='0 0 43 43'
      {...props}>
      <g data-name='Group 1599' transform='translate(22330 18460)'>
        <circle
          data-name='Ellipse 196'
          cx={21.5}
          cy={21.5}
          r={21.5}
          transform='translate(-22330 -18460)'
          fill='#4c6085'
        />
        <g fill='#fff'>
          <path d='M-22318.977-18444.344a3.611 3.611 0 011.4 2.3h-2.367a1.823 1.823 0 00-.719-.789 2.2 2.2 0 00-1.163-.293 2.175 2.175 0 00-1.7.711 2.768 2.768 0 00-.64 1.924 2.813 2.813 0 00.673 2.022 2.522 2.522 0 001.914.7 2.262 2.262 0 002.248-1.683h-2.821v-1.6h4.691v2.2a4.5 4.5 0 01-.836 1.5 4.305 4.305 0 01-1.47 1.122 4.664 4.664 0 01-2.045.43 4.863 4.863 0 01-2.444-.592 4.066 4.066 0 01-1.613-1.665 5.517 5.517 0 010-4.878 4.081 4.081 0 011.607-1.663 4.8 4.8 0 012.424-.594 4.621 4.621 0 012.862.848M-22313.732-18442.426a2.753 2.753 0 00-.642 1.924 2.757 2.757 0 00.642 1.917 2.449 2.449 0 003.454 0 2.74 2.74 0 00.646-1.918 2.759 2.759 0 00-.642-1.917 2.465 2.465 0 00-3.46-.006m4.081-2.166a4.391 4.391 0 011.666 1.671 5.084 5.084 0 01-.007 4.838 4.422 4.422 0 01-1.672 1.678 4.844 4.844 0 01-4.679 0 4.42 4.42 0 01-1.672-1.678 5.061 5.061 0 010-4.838 4.434 4.434 0 011.672-1.671 4.868 4.868 0 014.691 0M-22305.407-18435.955h2.305v-2.218h-2.305zm2.357-9.624l-.272 6.342h-1.878l-.273-6.342zM-22321.108-18433.53v4.188h-1.019v-2.619l-.905 2.619h-.882l-.911-2.625v2.625h-1.02v-4.188h1.246l1.138 2.917 1.116-2.917zM-22318.059-18430.888l-.524-1.551-.53 1.551zm.262.776h-1.578l-.262.77h-1.072l1.543-4.188h1.173l1.543 4.188h-1.084zM-22312.317-18429.342h-1.019l-1.7-2.589v2.589h-1.022v-4.218h1.019l1.7 2.613v-2.613h1.022zM-22311.614-18429.342h1.019v-4.218h-1.019zM-22308.874-18430.123h1.358v.781h-2.377v-4.218h1.019zM-22304.699-18430.888l-.524-1.551-.53 1.551zm.262.776h-1.578l-.262.77h-1.073l1.543-4.188h1.173l1.543 4.188h-1.084zM-22297.414-18434.976l.417.241.03-.052-.417-.241zM-22296.886-18432.786l.052.03.241-.418-.052-.03zM-22296.186-18435.315l.057-.1.066.1h.09l-.106-.156.1-.158h-.084l-.055.095-.064-.095h-.09l.1.153-.1.162zM-22296.016-18433.766c.1 0 .127-.127.127-.33a6.476 6.476 0 00-.1-.716.117.117 0 00.1-.123.159.159 0 10-.254 0 .117.117 0 00.1.123 6.463 6.463 0 00-.1.716c0 .2.025.33.127.33M-22296.223-18432.71h.076v-.313h-.076zM-22296.649-18435.201l-.314-.366-.046.039.314.366zM-22297.423-18433.21l.039.046.365-.314-.039-.046zM-22295.943-18435.316h.076v-.314h-.076zM-22297.678-18434.016h.314v-.076h-.314zM-22297.363-18434.124v-.087l-.1-.057.1-.066v-.09l-.156.106-.158-.1v.087l.095.056-.095.064v.09l.152-.1zM-22294.654-18434.112h.314v-.076h-.314zM-22294.654-18434.241h.314v-.076h-.314zM-22294.976-18434.792l.365-.314-.039-.046-.365.309zM-22294.654-18434.369h.314v-.076h-.314z' />
          <path d='M-22296.047-18432.38a1.781 1.781 0 111.866-1.779 1.824 1.824 0 01-1.866 1.779zm3.612-3.558l-.241.06v-.538l-.181-.3v-2.779l.512-.362v-.211l.09-.09h-.542v-.423l.482-.06v-.181l.181-.06-.542-.543-.662.181a2.447 2.447 0 00-1.987-2.488v-.165l-.271-.151v-1.268a.415.415 0 00-.3-.181v-.3l.181-.121-.181-.12v-.844l-.06-.06v-.543l-.091-.331-.09.332v.542l-.06.06v.844l-.181.12.181.121v.3a.415.415 0 00-.3.181v1.268l-.271.151v.165a2.447 2.447 0 00-1.987 2.488l-.662-.181-.542.543.181.06v.181l.482.06v.422h-.539l.09.09v.211l.512.362v2.774l-.181.3v.543l-.241-.06-1.445 1.266.12.241v5.065h9.874v-5.063l.12-.241z' />
          <path d='M-22295.066-18433.529l.417.241.03-.052-.417-.241zM-22295.815-18435.316h.076v-.314h-.076zM-22296.009-18433.023l-.109.314h.081l.077-.236.077.236h.081l-.109-.314zM-22295.2-18435.558l-.241.418.052.03.241-.418zM-22295.383-18433.115l.314.366.046-.039-.314-.366z' />
        </g>
      </g>
    </svg>
  );
};

export const Send = (props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={25}
      height={25}
      viewBox='0 0 35.734 33.277'
      {...props}>
      <g fill='#4c6085'>
        <path data-name='Path 4690' d='M0 0l9.074 15.938h26.66z' />
        <path data-name='Path 4691' d='M0 33.278l9.074-15.937h26.66z' />
      </g>
    </svg>
  );
};

export const WalletIcon = (props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='30.155'
      height='18.441'
      viewBox='0 0 30.155 18.441'
      {...props}>
      <g transform='translate(0.254 0.253)'>
        <path
          d='M420.954,235.982l.718-3.953a.435.435,0,1,1,.856.156l-.718,3.954a1.451,1.451,0,0,0,1.166,1.689l2.8.524a.435.435,0,0,1-.08.863c-.027,0-2.88-.532-2.88-.532a2.321,2.321,0,0,1-1.864-2.7Z'
          transform='translate(-420.916 -224.081)'
        />
        <path
          d='M113.193,115.476l9.644,1.77a1.451,1.451,0,0,0,1.689-1.165l1.461-7.962a1.452,1.452,0,0,0-1.165-1.689l-14.5-2.661a1.451,1.451,0,0,0-1.688,1.165l-.37,2.018a.435.435,0,1,1-.856-.157l.37-2.018a2.321,2.321,0,0,1,2.7-1.864l.041.008.066-.359a2.1,2.1,0,0,1,2.447-1.688l14.929,2.739a2.1,2.1,0,0,1,1.688,2.447l-1.54,8.393a2.1,2.1,0,0,1-2.447,1.688l-.256-.047-.026.144a2.32,2.32,0,0,1-2.7,1.864l-9.644-1.77a.435.435,0,0,1,.157-.856Zm12.628-.191a1.233,1.233,0,0,0,1.434-.989l1.54-8.393a1.233,1.233,0,0,0-.989-1.434l-14.929-2.739a1.231,1.231,0,0,0-1.434.989l-.066.359,13.6,2.5a2.324,2.324,0,0,1,1.864,2.7l-1.278,6.962Z'
          transform='translate(-106.278 -100.839)'
        />
        <path
          d='M274.7,205.051a3.845,3.845,0,1,1-3.845-3.845A3.85,3.85,0,0,1,274.7,205.051Zm-6.82,0a2.975,2.975,0,1,0,2.975-2.975A2.978,2.978,0,0,0,267.884,205.051Z'
          transform='translate(-260.557 -195.383)'
        />
        <path
          d='M2.956,290.461l-2.624-.641a.435.435,0,0,1,.207-.845l2.624.642a.435.435,0,1,1-.207.845Z'
          transform='translate(26.145 -278.047)'
        />
        <path
          d='M59.168,369.713l2.624.641a.435.435,0,1,1-.207.845l-2.624-.641a.435.435,0,1,1,.207-.845Z'
          transform='translate(-35.886 -354.102)'
        />
        <path
          d='M12.6,324.15l4.082,1.05a.435.435,0,1,1-.217.843l-4.082-1.05a.435.435,0,1,1,.217-.843Z'
          transform='translate(11.927 -311.181)'
        />
        <path
          d='M82.4,279.672a.436.436,0,0,1-.1-.012l-.551-.13a.435.435,0,1,1,.2-.847l.551.13a.435.435,0,0,1-.1.859Z'
          transform='translate(-57.916 -268.353)'
        />
        <path
          d='M5.732,390.994l.991.233a.435.435,0,1,1-.2.847l-.991-.233a.435.435,0,1,1,.2-.847Z'
          transform='translate(22.279 -374.148)'
        />
      </g>
    </svg>
  );
};

export const WalletHeaderIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='34.362'
      height='33.034'
      viewBox='0 0 34.362 33.034'>
      <g
        id='Component_163_1'
        data-name='Component 163 – 1'
        transform='translate(1 1.008)'>
        <path
          id='Path_5908'
          data-name='Path 5908'
          d='M161.321,23.937l13.3-3.63-.7-1.424a1.874,1.874,0,0,0-2.51-.847l-11.906,5.9Z'
          transform='translate(-153.852 -17.84)'
          fill='none'
          stroke='#4c6085'
          strokeWidth='2'
        />
        <path
          id='Path_5909'
          data-name='Path 5909'
          d='M335.161,86.46a1.873,1.873,0,0,0-.495.067l-3.125.854L322,89.985h15.552l-.584-2.143A1.87,1.87,0,0,0,335.161,86.46Z'
          transform='translate(-310.614 -83.889)'
          fill='none'
          stroke='#4c6085'
          strokeWidth='2'
        />
        <path
          id='Path_5910'
          data-name='Path 5910'
          d='M28.627,215.56H1.817a1.79,1.79,0,0,0-1.418.7,1.9,1.9,0,0,0-.334.678,2,2,0,0,0-.065.491V238.3a1.845,1.845,0,0,0,1.814,1.873H28.623a1.845,1.845,0,0,0,1.814-1.873v-5.226H19.674a3.137,3.137,0,0,1-3.083-3.185v-4.166a3.225,3.225,0,0,1,.874-2.218,3.017,3.017,0,0,1,1.839-.94,2.97,2.97,0,0,1,.366-.022H30.437v-5.114A1.839,1.839,0,0,0,28.627,215.56Z'
          transform='translate(0 -209.152)'
          fill='none'
          stroke='#4c6085'
          strokeWidth='2'
        />
        <path
          id='Path_5911'
          data-name='Path 5911'
          d='M506.7,437.252a1.872,1.872,0,0,0-.656-.39,1.911,1.911,0,0,0-.607-.1H494.273a1.874,1.874,0,0,0-1.873,1.873v4.17a1.874,1.874,0,0,0,1.873,1.873h11.168a1.91,1.91,0,0,0,.607-.1,1.817,1.817,0,0,0,.656-.39,1.867,1.867,0,0,0,.611-1.382v-4.17A1.867,1.867,0,0,0,506.7,437.252Zm-8.52,3.84a.937.937,0,0,1-.937.937h-.622a.937.937,0,0,1-.937-.937v-.622a.918.918,0,0,1,.36-.734.947.947,0,0,1,.577-.2h.622a.937.937,0,0,1,.937.937v.622Z'
          transform='translate(-474.952 -421.717)'
          fill='none'
          stroke='#4c6085'
          strokeWidth='2'
        />
      </g>
    </svg>
  );
};

export const HandShake = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32.98}
      height={31.013}
      viewBox="0 0 32.98 31.013"
      {...props}
    >
      <path
        data-name="Path 11680"
        d="M30.213 2.762a9.5 9.5 0 00-13.724.342A9.472 9.472 0 103.008 16.389a3.32 3.32 0 001.865 5.669 3.322 3.322 0 003.3 3.536 3.318 3.318 0 004.143 2.974 3.321 3.321 0 005.536 1.477c1.013-1.007 1.819-1.642 1.87-3.167a3.323 3.323 0 003.148-3.188 3.322 3.322 0 003.189-3.189 3.324 3.324 0 003.192-3.4l.962-.962a9.474 9.474 0 000-13.377zM4.459 17.929l.9-.9a1.2 1.2 0 011.694 1.694l-.9.9a1.2 1.2 0 01-1.694-1.694zm2.519 4.355a1.19 1.19 0 01.351-.847l.9-.9a1.2 1.2 0 011.693 1.694l-.8.8a1.256 1.256 0 01-.953.457 1.2 1.2 0 01-1.191-1.204zm3.646 3.929a1.2 1.2 0 010-1.694l.8-.8a1.213 1.213 0 011.8-.106 1.2 1.2 0 010 1.694l-.9.9a1.2 1.2 0 01-1.694 0zm6.636 1.432l-.9.9a1.2 1.2 0 01-1.694 0 1.2 1.2 0 010-1.694l.9-.9a1.2 1.2 0 111.694 1.694zm9.527-9.6a1.2 1.2 0 01-1.694 0l-4.705-4.705-1.5 1.5 4.712 4.697a1.2 1.2 0 01-1.7 1.694l-4.621-4.626-.08-.08-1.5 1.5.08.08 4.626 4.626a1.2 1.2 0 11-1.694 1.694 3.314 3.314 0 00-3.144-.82 3.328 3.328 0 00-3.189-2.448 3.324 3.324 0 00-2.87-3.054 3.319 3.319 0 00-4.919-3.116 7.363 7.363 0 1110.4-10.383L12.38 7.213l2.095 2.095a4.794 4.794 0 005.937.664l6.375 6.373a1.2 1.2 0 010 1.694zm1.931-3.392l-.322.322q-.055-.061-.113-.119l-7.789-7.791-.748.748a2.674 2.674 0 01-3.777 0l-.6-.6 2.956-2.956c7.18-6.608 17 3.217 10.392 10.393z"
        fill="#1b2560"
      />
    </svg>
  )
}

export const HandShakeFilled = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={29.823}
      viewBox="0 0 32 29.823"
      {...props}
    >
      <g data-name="handshake (1)" fill="#1b2560">
        <path
          data-name="Path 11674"
          d="M8.694 20.51a1.339 1.339 0 00-1.729-.134l-.013-.009-1.149 1.149a1.321 1.321 0 00-.39.942 1.339 1.339 0 001.333 1.333 1.4 1.4 0 001.061-.508l.887-.887a1.332 1.332 0 000-1.885z"
        />
        <path
          data-name="Path 11675"
          d="M5.499 16.604a1.335 1.335 0 00-1.885 0L2.609 17.61a1.333 1.333 0 001.885 1.885L5.5 18.489a1.334 1.334 0 00-.001-1.885z"
        />
        <path
          data-name="Path 11676"
          d="M11.42 23.55a1.325 1.325 0 00-.943.391l-1.006 1.006-.014.015a1.333 1.333 0 001.9 1.871l1.007-1.007a1.337 1.337 0 00-.944-2.276z"
        />
        <path
          data-name="Path 11677"
          d="M20.366 8.753a5.337 5.337 0 01-6.609-.74l-2.332-2.331 2.91-2.91A8.2 8.2 0 102.756 14.33a3.693 3.693 0 015.477 3.468 3.7 3.7 0 013.194 3.4 3.709 3.709 0 013.55 2.723 3.7 3.7 0 013.707 1.131l.027-.031a1.334 1.334 0 001.71-2.009l-5.3-5.3 1.664-1.664 5.238 5.238a1.333 1.333 0 001.885-1.885l-5.232-5.239 1.664-1.664 5.238 5.238a1.333 1.333 0 001.885-1.885z"
        />
        <path
          data-name="Path 11678"
          d="M29.612 2.391a8.191 8.191 0 00-11.568 0l-3.29 3.291.667.667a2.976 2.976 0 004.2 0l.832-.832c.443.447 8.567 8.558 8.8 8.8a8.226 8.226 0 00.359-11.926z"
        />
        <path
          data-name="Path 11679"
          d="M16.859 26.544a1.335 1.335 0 00-1.885 0l-1.006 1.006a1.333 1.333 0 001.885 1.885l1.006-1.006a1.341 1.341 0 000-1.885z"
        />
      </g>
    </svg>
  )
}